<template>
  <div id="ExamManage">
    <div>
      <van-tabs v-model="active">
        <!-- color="#007aff" -->
        <van-tab title="全部考试" @click="active = 0"></van-tab>
        <van-tab title="进行中的考试" @click="active = 1"></van-tab>
        <van-tab title="暂停 / 归档" @click="active = 2"></van-tab>
      </van-tabs>
    </div>
    <div>
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o"
        >需要在考试中管理多个岗位的工作人员,可以向右滑动考试信息多次申请工作岗位.</van-notice-bar
      >
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- 滑动单元格 -->
        <van-swipe-cell v-for="(item, index) in drawList" :key="index">
          <template slot="default">
            <van-row :border="true">
              <van-col span="4">
                <span class="fa-stack fa-lg color-blue mt-3 ml-4">
                  <i class="fa fa-square fa-stack-2x"></i>
                  <i class="fa fa-wpforms fa-stack-1x fa-inverse"></i>
                </span>
              </van-col>
              <van-col span="20" class="text-left" @click="joinBtn(item)">
                <van-cell :title="item.WorkName" size="large">
                  <template slot="title">
                    <van-row>
                      <van-col span="20">
                        <div class="mr-1">
                          <span>{{ item.WorkName }}</span>
                          <van-tag plain round>{{
                            item.WorkStatusName
                          }}</van-tag>
                          <template v-if="item.UserRoleList">
                            <template v-if="item.UserRoleList.length > 0">
                              <p
                                class="m-0 p-0 color-gray"
                                v-for="(e, i) in item.UserRoleList"
                                :key="i"
                              >
                                <small v-if="e.ApplyStatus == 1">
                                  <div class="text-overflow">
                                    <i
                                      class="fa fa-fw"
                                      :class="
                                        e.ApplyStatus == 1
                                          ? 'fa-check-circle-o color-green'
                                          : 'fa-circle-o-notch'
                                      "
                                    ></i>
                                    {{ e.OrganName }} [{{ e.RoleName }}]
                                  </div>
                                  <!-- [{{e.RoleName}}]-{{e.ApplyStatusName}} -->
                                </small>
                              </p>
                            </template>
                          </template>
                        </div>
                      </van-col>
                      <van-col span="4">
                        <van-tag
                          plain
                          click="ml-2"
                          :type="
                            item.UserRoleList && item.UserRoleList.length > 0
                              ? 'success'
                              : 'warning'
                          "
                          >{{ item.ApplyStatusName
                          }}<!-- {{ (item.UserRoleList && item.UserRoleList.length > 0) ? '已申请' : '未申请' }} --></van-tag
                        >
                      </van-col>
                    </van-row>
                  </template>
                  <template slot="label">
                    <small class="ls-1">考试工作</small>
                    <small class="ls-1">{{
                      item.BeginTime.slice(0, -7)
                    }}</small>
                    <small class="ls-1">至</small>
                    <small class="ls-1">{{ item.EndTime.slice(0, -7) }}</small>
                  </template>
                </van-cell>
              </van-col>
            </van-row>
          </template>
          <!-- 123 -->
          <template slot="right">
            <van-button
              slot="right"
              square
              type="info"
              class="h-100"
              text="岗位详情"
              @click="toBeBtn(item)"
            />
          </template>
        </van-swipe-cell>
        <van-divider v-if="this.drawList.length < 1"
          >没有找到查询结果</van-divider
        >
      </van-pull-refresh>
    </div>

    <!-- 申请参加 -->
    <van-popup
      v-model="sheet1"
      :style="{ height: '80%' }"
      round
      closeable
      position="bottom"
    >
      <van-nav-bar :title="sheet1Content.item.WorkName" />
      <div class="m-2 text-left">
        <van-cell-group
          :border="false"
          v-for="(e, i) in sheet1Content.item.UserRoleList"
          :key="i"
        >
          <van-cell :title="e.OrganName" :label="e.ApplyStatusName">
            <template slot="title">
              {{ e.OrganName }}
              <b>{{ e.ApplyStatusName }}</b>
            </template>
            <template slot="label">
              {{ e.RangeName }}
              <br />
              {{ e.RoleName }}
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <van-divider>提交考试岗位申请</van-divider>
      <div class="m-4">
        <div class="m-1">
          <el-select
            v-model="sheet1Content.organId"
            filterable
            placeholder="考试机构"
            class="w-100"
          >
            <el-option
              v-for="(item, index) in sheet1Content.data"
              :key="index"
              :label="item.OrganName"
              :value="item.OrganID"
            ></el-option>
          </el-select>
        </div>
        <div class="m-1">
          <el-select
            v-model="sheet1Content.rangeId"
            v-show="sheet1Content.rangeList.length > 1 ? true : false"
            filterable
            placeholder="工作范围"
            class="w-100"
          >
            <el-option
              v-for="(item, index) in sheet1Content.rangeList"
              :key="index"
              :label="item.RangeName"
              :value="item.RangeID"
            ></el-option>
          </el-select>
        </div>
        <div class="m-1">
          <el-select
            v-model="sheet1Content.roleId"
            filterable
            placeholder="考试岗位"
            class="w-100"
          >
            <el-option
              v-for="(item, index) in sheet1Content.roleList"
              :key="index"
              :label="item.RoleName"
              :value="item.RoleID"
            ></el-option>
          </el-select>
        </div>
        <div class="m-1 mt-4">
          <van-button
            type="info"
            class="w-100"
            @click="toBeApplyBtn"
            style="border-radius: 5px;"
            >提交申请</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 申请反馈 -->
    <van-popup v-model="sheet2" style="width:80%;">内容</van-popup>

    <!-- 进入考试 -->
    <van-popup v-model="sheet3" style="width:80%;">进入考试</van-popup>
  </div>
</template>

<script>
export default {
  name: "ExamManage",
  data () {
    return {
      active: 1,
      isLoading: false,
      sheet1: false,
      sheet1Content: {
        item: {},
        data: [],
        organId: "",
        rangeList: [],
        rangeId: "",
        roleList: [],
        roleId: ""
      },
      sheet2: false,
      sheet3: false,
      drawList: [],
      roleSelect: "" //所选角色
    };
  },
  watch: {
    active: function (newVal) {
      this.active = newVal;
      this.drawWorkList();
    },
    "sheet1Content.organId": {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          //清空已选范围
          this.sheet1Content.rangeId = "";
          //清空已选岗位
          this.sheet1Content.roleId = "";
          //循环返回数据
          this.sheet1Content.data.forEach(item => {
            //判断当前选择的岗位数据内容
            if (item.OrganID == newVal) {
              //将当前选择岗位管理范围内容赋值
              this.sheet1Content.rangeList = item.RangeList;
              //判断岗位范围是否是唯一值
              if (item.RangeList.length == 1) {
                //如果岗位范围只有一个地区则自动赋值
                this.sheet1Content.rangeId = item.RangeList[0].RangeID;
              }
              //将当前选择的岗位内容赋值
              this.sheet1Content.roleList = item.RoleList;
            }
          });
        }
      }
    }
  },
  methods: {
    onRefresh () {
      setTimeout(() => {
        this.drawWorkList();
        this.isLoading = false;
      }, 500);
    },
    drawWorkList () {
      //清空工作任务渲染列表
      this.drawList = [];
      //获取工作任务列表
      this.apiWorkGet({}, this, res => {
        if (res.code == 20000) {
          res.data.forEach(element => {
            if (this.active == 0) {
              this.drawList.push(element);
            } else if (this.active == 2 || this.active == 3) {
              if (element.WorkStatus == 2 || element.WorkStatus == 3) {
                this.drawList.push(element);
              }
            } else {
              if (element.WorkStatus == this.active) {
                this.drawList.push(element);
              }
            }
          });
        } else {
          //eslint-disable-next-line
          console.log("获取工作列表返回值有误, res:", res);
        }
      });
    },
    //申请参加
    toBeBtn (item) {
      this.sheet1Content.item = item;
      this.sheet1Content.data = [];
      this.apiRoleGet({ WorkID: item.WorkID }, this, res => {
        if (res.code == 20000) {
          this.sheet1Content.data = res.data;
          this.sheet1Content.organId = "";
          //绑定机构列表后将当前用户机构id赋给组件默认值
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].OrganID == this.getAuth().OrganID) {
              this.sheet1Content.organId = this.getAuth().OrganID;
              break;
            }
          }
          this.sheet1 = true;
        } else {
          this.$toast('获取申请机构列表失败，请稍后再试。')
        }
      });
    },
    //申请考试按钮
    toBeApplyBtn () {
      // eslint-disable-next-line
      console.log(
        "WorkID",
        this.sheet1Content.item.WorkID,
        ";OrganID",
        this.sheet1Content.organId,
        ";RangeID",
        this.sheet1Content.rangeId,
        ";RoleID",
        this.sheet1Content.roleId
      );
      if (this.sheet1Content.organId == "") {
        this.$toast("未选择机构");
        return;
      }
      if (this.sheet1Content.rangeId == "") {
        this.$toast("未选择工作范围");
        return;
      }
      if (this.sheet1Content.roleId == "") {
        this.$toast("未选择岗位");
        return;
      }
      this.apiApplyPost(
        {
          WorkID: this.sheet1Content.item.WorkID,
          OrganID: this.sheet1Content.organId,
          RangeID: this.sheet1Content.rangeId,
          RoleID: this.sheet1Content.roleId
        },
        this,
        res => {
          if (res.code == 20000) {
            this.sheet1 = false;
            this.drawWorkList();
          }
          this.$toast(res.message);
        }
      );
    },
    //详情
    detailBtn () {
      this.sheet2 = true;
    },
    //进入考试
    joinBtn (item) {
      if (item.UserRoleList.length > 0) {
        this.apiWorkGet({ WorkID: item.WorkID }, this, res => {
          if (res.code == 20000) {
            //eslint-disable-next-line
            // console.log("res", res);
            if (res.data.Organ.length > 0) {
              this.setWork(res.data); //将用户登录考试后的信息存储
              this.setAddr(res.data.Organ[0]); //将机构下第一个考点设为默认选项
              this.$router.push(this.$backurl());
            } else {
              this.$toast("当前考试所申请角色没有通过审核,请等待管理员审核.");
            }
          } else {
            this.$toast(res.message);
          }
        });
      } else {
        this.$dialog
          .confirm({
            title: "提示",
            message: "还未申请参加这场考试,是否申请?"
          })
          .then(() => {
            // on confirm
            this.toBeBtn(item);
          })
          .catch(() => {
            // on cancel
          });
      }
    }
  },
  created () {
    this.drawWorkList();
  }
};
</script>

<style scoped>
</style>
